import React from "react";

import * as styles from "../XboxOnboardPage.module.css";

export const XboxOnboardStatus = ({
  message,
  variant,
}: Readonly<{
  message: string;
  variant: "info" | "warning" | "error";
}>) => {
  const variantClass =
    variant === "info"
      ? styles.statusInfo
      : variant === "warning"
      ? styles.statusWarning
      : styles.statusError;

  return <div className={`${styles.statusMessage} ${variantClass}`}>{message}</div>;
};
